export default "__VITE_ASSET__DGI6_C4z__"